import type { Snippet } from '../../../../../shared/snippets';

import useSnippetsWithQueryParams from './useSnippetsWithQueryParams';

/**
 * We don't have a dedicated endpoint for serving data about just one snippet,
 * which is fine because the /snippets endpoint already includes all the data
 * about each snippet that we need. This hook "fetches" them (really they would already
 * be fetched an in the React Query cache).
 *
 * @param {string} userRevisionLocator - The given project revision locator to fetch snippets for.
 * @param {string} [selectedSnippetId] - The selected snippet ID.
 */
const useSnippetById = (userRevisionLocator: string, selectedSnippetId?: string) => {
  const { data: snippets, ...rest } = useSnippetsWithQueryParams(userRevisionLocator);

  const snippet: Snippet | null = selectedSnippetId
    ? snippets?.results.find(({ id }) => id === selectedSnippetId) ?? null
    : null;

  return {
    snippet,
    ...rest,
  };
};

export default useSnippetById;
